import axios from 'axios'
import { Dispatch } from 'redux'
import apiErrorHandler from '../helpers/apiErrorHandler'

const HEADERS = { 'Content-Type': 'application/json' }

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/stream`,
    withCredentials: false
})

axiosInstance.interceptors.request.use(
    async req => {
        // Add configurations here
        req.headers['Authorization'] =
            'Bearer: ' + localStorage.getItem('carnivore-token')
        return req
    },
    err => {
        return Promise.reject(err)
    }
)

export class StreamService {
    private dispatch: Dispatch

    constructor(dispatch: Dispatch) {
        this.dispatch = dispatch
    }


    async stopStream() {
        return axiosInstance
            .post('/stop', {

            })
            .then(res => res.data.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }

    async startStream() {
        return axiosInstance
            .post('/start', {

            })
            .then(res => res.data.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }

    async getStreamConfig(password: string) {
        return axiosInstance
            .post('/config', {
                password
            })
            .then(res => res.data.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }

    async getStreamStats(id: string) {
        return axiosInstance
            .get(`/${id}`)
            .then(res => res.data.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }
}
